import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { MANIFESTO } from "@/data/site";
import { Reveal, StaggerItem } from "@/components/Reveal";
import Marquee from "@/components/Marquee";
import Stamp from "@/components/Stamp";
import Seo, { breadcrumbLd } from "@/components/Seo";
import { PAGE_SEO } from "@/lib/seo";
import ensemble from "@/assets/brand/ensemble.jpeg";
import pouches from "@/assets/brand/pouches.png";

const Movement = () => {
  const { t, tr } = useLang();
  return (
    <div data-testid="page-movement">
      <Seo {...PAGE_SEO.movement} jsonLd={[breadcrumbLd([{ name: "Home", path: "/" }, { name: "Movement", path: "/movement" }])]} />
      {/* Hero */}
      <section className="bg-blush border-b border-ink py-16 md:py-24">
        <div className="max-w-[1440px] mx-auto px-4 md:px-8">
          <Reveal>
            <p className="kicker text-ink/60">Anti Unhealthy Club™</p>
            <h1 className="display uppercase text-6xl md:text-[9vw] leading-[0.84] mt-3 text-brand">
              {t.movement.title}
            </h1>
            <p className="mt-6 max-w-2xl text-xl font-medium text-ink/80">{t.movement.intro}</p>
          </Reveal>
        </div>
      </section>

      <Marquee text={t.marquee} bg="bg-lime" color="text-ink" />

      {/* Key visual */}
      <section className="bg-cream border-b border-ink py-14 md:py-20">
        <div className="max-w-[1440px] mx-auto px-4 md:px-8">
          <Reveal className="border border-ink overflow-hidden bg-blush">
            <img src={pouches} alt="Anti Unhealthy Club Standbodenbeutel" className="w-full" />
          </Reveal>
        </div>
      </section>

      {/* Manifesto */}
      <section className="bg-cream border-b border-ink py-16 md:py-24">
        <div className="max-w-[1440px] mx-auto px-4 md:px-8">
          <Reveal>
            <h2 className="display uppercase text-5xl md:text-7xl leading-[0.85] text-brand">{t.manifestoTitle}</h2>
          </Reveal>
          <StaggerItem className="mt-10">
            <div className="grid md:grid-cols-2 gap-px bg-ink border border-ink">
              {MANIFESTO.map((c) => (
                <div key={c.n} className="bg-cream p-8 md:p-10 h-full hover:bg-blush transition-colors duration-300">
                  <span className="display text-6xl md:text-7xl" style={{ color: c.color }}>{c.n}</span>
                  <h3 className="display uppercase text-2xl md:text-3xl mt-4 leading-none">{tr(c.title)}</h3>
                  <p className="mt-3 font-medium text-ink/70">{tr(c.body)}</p>
                </div>
              ))}
            </div>
          </StaggerItem>
        </div>
      </section>

      {/* Vision */}
      <section className="bg-peach py-16 md:py-24">
        <div className="max-w-[1440px] mx-auto px-4 md:px-8 grid lg:grid-cols-2 gap-10 items-center">
          <Reveal>
            <div className="border border-ink overflow-hidden">
              <img src={ensemble} alt="Brand Ensemble" className="w-full" />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="flex items-start gap-4">
              <Stamp size={84} bg="bg-lime" />
              <div>
                <p className="kicker text-pink">{t.movement.visionTitle}</p>
                <h2 className="display uppercase text-4xl md:text-6xl leading-[0.85] mt-2 text-brand">Body · Mind · Soul</h2>
              </div>
            </div>
            <p className="mt-6 text-lg font-medium text-ink/80 max-w-xl">{t.movement.vision}</p>
            <Link to="/shop" className="btn bg-ink text-cream h-14 px-8 mt-8 inline-flex hover:bg-pink">
              {t.movement.ctaShop} <ArrowRight className="w-5 h-5" strokeWidth={2} />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Movement;
